import React from "react";

const TechnicalOverview = ({ product }) => {
  const symbols = product.acf.product_analysis_technical_overview_chart
    .split("\r\n")
    .find(item => item.includes("symbol"))
    .replace(`"symbol":`, "");
  const index = symbols.indexOf(":");
  const exchange = symbols.slice(0, index).replace(`"`, "").trim();
  const currency = symbols.slice(index + 1, symbols.length - 1).replace(`"`, "").trim();
  
  const scriptTechnicalChart = `symbol=${encodeURIComponent(`${exchange}:${currency}`)}&interval=D&symboledit=1&saveimage=1&toolbarbg=f1f3f6&studies=MASimple%40tv-basicstudies%1FMAExp%40tv-basicstudies&theme=light&style=1&timezone=Asia%2FHo_Chi_Minh&studies_overrides=%7B%7D&overrides=%7B%7D&enabled_features=%5B%5D&disabled_features=%5B%5D&locale=vi_VN`;
  
  return (
    <div className="tradingview-widget-container">
      <iframe 
        tite={currency}
        src={`https://s.tradingview.com/widgetembed/?${scriptTechnicalChart}`} 
        width='100%' height='386px' 
        frameBorder="0" 
        allowtransparency="true" 
        scrolling="no"
      ></iframe>
      <div className="tradingview-widget-copyright">
        <a href={`https://www.tradingview.com/symbols/${currency}/?exchange=${exchange}`} rel="noopener noreferrer" target="_blank">
          <span className="blue-text">{currency} Chart</span>
        </a> by TradingView
      </div>
    </div>
  );
};

export default TechnicalOverview;
